import { QueryKeys } from "@/constants/Query";
import { withMultipleEncountersHandler } from "@/features/Patient/MedicalRecords/MedicalHistory/useMedicalHistoryErrorHandler";
import type { ApiError } from "@/hooks/useApi";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";

interface ReassignEpisodeOfCareRequest {
  targetEpisodeOfCareId: string;
}

export const useReassignEpisodeOfCare = ({
  patientId,
  motherEncounterId,
  childEncounterId,
  onSuccess,
  onError,
}: {
  patientId: string;
  motherEncounterId: string;
  childEncounterId: string;
  onSuccess?: () => void;
  onError?: (error: ApiError) => void;
}) => {
  const queryClient = useQueryClient();
  return useApiMutation({
    mutationOptions: {
      mutationFn: (data: ReassignEpisodeOfCareRequest) =>
        axiosInstance.post(
          `/charting/encounter-charting/${childEncounterId}/reassign`,
          data,
        ),
      mutationKey: QueryKeys.Patient.Chart.EpisodesOfCare.DEFAULT({
        patientId,
        encounterId: motherEncounterId,
      }),
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey:
            QueryKeys.Patient.MedicalRecords.MedicalHistory.DEFAULT(patientId),
        });
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.Conditions.DEFAULT(patientId),
        });
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.EpisodesOfCare.DEFAULT({
            patientId,
            encounterId: motherEncounterId,
          }),
        });
        onSuccess?.();
      },
      onError: withMultipleEncountersHandler(onError),
    },
  });
};
